import { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface PageLayoutProps {
  children: ReactNode
  className?: string
}

interface PageLayoutHeaderProps {
  children: ReactNode
  className?: string
}

interface PageLayoutContentProps {
  children: ReactNode
  className?: string
  layout?: 'sidebar-left' | 'sidebar-right' | 'full'
}

interface PageLayoutSidebarProps {
  children: ReactNode
  className?: string
}

interface PageLayoutMainProps {
  children: ReactNode
  className?: string
}

function PageLayoutRoot({ children, className }: PageLayoutProps) {
  return (
    <div
      className={cn('min-h-screen px-2 pb-8 sm:px-0', className)}
      style={{ backgroundColor: 'rgb(245, 245, 245)' }}
    >
      {children}
    </div>
  )
}

function PageLayoutHeader({ children, className }: PageLayoutHeaderProps) {
  return <div className={cn('', className)}>{children}</div>
}

function PageLayoutContent({
  children,
  className,
  layout = 'sidebar-left',
}: PageLayoutContentProps) {
  const layoutClasses = {
    'sidebar-left': 'mt-3 flex flex-col gap-3 lg:flex-row',
    'sidebar-right': 'mt-3 flex flex-col gap-3 lg:flex-row-reverse',
    full: 'mt-3 flex flex-col gap-3',
  }

  return <div className={cn(layoutClasses[layout], className)}>{children}</div>
}

function PageLayoutSidebar({ children, className }: PageLayoutSidebarProps) {
  return (
    <div
      className={cn('order-2 w-full space-y-3 lg:order-1 lg:w-1/4', className)}
    >
      {children}
    </div>
  )
}

function PageLayoutMain({ children, className }: PageLayoutMainProps) {
  return (
    <div
      className={cn('order-1 w-full flex-1 space-y-3 lg:order-2', className)}
    >
      {children}
    </div>
  )
}

export const PageLayout = Object.assign(PageLayoutRoot, {
  Header: PageLayoutHeader,
  Content: PageLayoutContent,
  Sidebar: PageLayoutSidebar,
  Main: PageLayoutMain,
})
